import { render, staticRenderFns } from "./project.vue?vue&type=template&id=ea2d24a8&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=ea2d24a8&prod&lang=scss&scoped=true"
import style1 from "./project.vue?vue&type=style&index=1&id=ea2d24a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2d24a8",
  null
  
)

export default component.exports